<script setup lang="ts">
import type { SelectOption } from '@/js/account/components/base/BaseSelect.vue';
import { classNames } from '@/js/lib/bem';

defineProps<{
  options: SelectOption[]
  modelValue: string
  listboxId?: string
  label?: string
}>();

const emit = defineEmits<{
  select: [value: string]
}>();

const cn = classNames('sort-select-option-list');
</script>

<template>
  <div :id="listboxId" role="listbox" :aria-label="label" :class="cn()">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      role="option"
      :class="cn('option', { selected: option.value === modelValue })"
      :aria-selected="option.value === modelValue"
      @click="emit('select', option.value)"
    >
      <span :class="cn('option-label')">{{ option.label }}</span>
      <span
        v-if="option.value === modelValue"
        :class="cn('option-check')"
        aria-hidden="true"
      />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.sort-select-option-list {
  display: flex;
  flex-direction: column;

  &__option {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px 16px;
    color: var(--color-text-secondary, #4c4c4c);
    font-weight: 400;
    font-size: 14px;
    font-family: var(--font-family-sans);
    line-height: 1.2;
    text-align: left;
    background: transparent;
    border: none;
    cursor: pointer;

    &:hover {
      background-color: var(--color-background-primary, #e9f0e2);
    }

    &_selected {
      color: var(--color-text-primary, #101010);
    }
  }

  &__option-label {
    flex: 1;
  }

  &__option-check {
    flex-shrink: 0;
    width: 16px;
    height: 16px;

    &::before {
      display: block;
      color: var(--color-primary, #73805b);
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      content: '✓';
    }
  }
}
</style>
